export default React.PropTypes.arrayOf(React.PropTypes.shape({
  type: React.PropTypes.string.isRequired,
  enabled: React.PropTypes.bool.isRequired,
  price: React.PropTypes.number.isRequired,
  currency: React.PropTypes.string,
  period: React.PropTypes.number,
}));



// WEBPACK FOOTER //
// ./src/shared/shapes/deal-info.js